export const en = {
  sign_in_title: 'ASF heatmap',
  sign_in_button: 'Sign in with Google',
  sign_in_failed: 'Sign-in failed. Please try again.',
  no_access_title: 'No access',
  no_access_body:
    'Your account does not have access to this map. Contact the administrator.',
  sign_out: 'Sign out',
  updating: 'Updating, please wait…',
  still_processing: 'The update is taking longer than usual.',
  heatmap_unavailable: 'The heatmap could not be updated.',
  error_title: 'The map could not be loaded',
  retry: 'Retry',
  settings: 'Settings',
  close: 'Close',
  refresh_data: 'Refresh map',
  show_borders: 'Show hunting-ground borders',
  show_sub_area: 'Show {{name}}',
  heatmap_opacity: 'Heatmap opacity',
  unnamed_area: '(unnamed area)',
  area_coverage_label: '{{name}}: {{value}}',
  area_status: '{{name}}: {{status}}',
} as const
